import React from 'react';
import { Button, Text } from '@zillow/constellation';
import styled from 'styled-components';
import { ComposeDocumentType, SourcePage } from './types/compose-types';
import ComposeDocumentItem from './ComposeDocumentItem';

const NewDocumentsPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  height: 100%;
`;

const SectionHeading = styled(Text)`
  padding: 0.75rem;
`;

const SectionText = styled(Text)`
  padding: 0.75rem;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 0.75rem;
`;

const ComposeDocumentListContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
`;

const AddDocumentContainer = styled.div`
  padding-top: 1rem;
  padding-left: 0.5rem;
  padding-bottom: 1rem;
`;

export type ComposeActions = {
  onAddComposeDocument: () => void;
  onComposeDocumentSelection: (compDocId: string) => void;
  onPageRangesChange: (selectedPageRanges: string) => void;
  onNameChange: (name: string) => void;
  onDeleteComposeDocument: (compDocId: string) => void;
};
type ComposeDocumentsPanelProps = ComposeActions & {
  activeComposeId: string | null;
  composeDocumentList: Array<ComposeDocumentType>;
  pages: Array<SourcePage>;
  hasError: boolean;
};

function ComposeDocumentsPanel({
  activeComposeId,
  composeDocumentList,
  pages,
  onAddComposeDocument,
  onComposeDocumentSelection,
  onPageRangesChange,
  onNameChange,
  onDeleteComposeDocument,
  hasError,
}: ComposeDocumentsPanelProps) {
  return (
    <NewDocumentsPanelContainer>
      <SectionHeading fontType="bodySmallHeading">Split Summary</SectionHeading>
      <SummaryRow>
        <SectionText fontType="bodySmall">
          To get started, select the pages that you would like to extract into a
          newly created copy of the original. Create additional documents as
          needed.
        </SectionText>
      </SummaryRow>

      <ComposeDocumentListContainer>
        {composeDocumentList.map((composeDocument, index: number) => (
          <ComposeDocumentItem
            key={composeDocument.id}
            isActive={activeComposeId === composeDocument.id}
            composeDocument={composeDocument}
            pages={pages}
            order={index + 1}
            hasError={hasError}
            onAddComposeDocument={onAddComposeDocument}
            onComposeDocumentSelection={onComposeDocumentSelection}
            onPageRangesChange={onPageRangesChange}
            onNameChange={onNameChange}
            onDeleteComposeDocument={onDeleteComposeDocument}
          />
        ))}
        <AddDocumentContainer>
          <Button aria-label="Add new document" onClick={onAddComposeDocument}>
            Add new document
          </Button>
        </AddDocumentContainer>
      </ComposeDocumentListContainer>
    </NewDocumentsPanelContainer>
  );
}

export default ComposeDocumentsPanel;
